/**
 * @generated SignedSource<<90d50cdcf380b3a9fe613330e6d712ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type templatePreviewContentfulRelayFragment$data = {
  readonly templateNameExternal: string | null | undefined;
  readonly templatePreviews: {
    readonly items: ReadonlyArray<{
      readonly url: string | null | undefined;
    } | null | undefined>;
  } | null | undefined;
  readonly templateTypeCollection: {
    readonly items: ReadonlyArray<{
      readonly sys: {
        readonly id: string;
      };
    } | null | undefined>;
  } | null | undefined;
  readonly " $fragmentType": "templatePreviewContentfulRelayFragment";
};
export type templatePreviewContentfulRelayFragment$key = {
  readonly " $data"?: templatePreviewContentfulRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"templatePreviewContentfulRelayFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "templatePreviewContentfulRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "templateNameExternal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductTemplateTemplateTypeCollection",
      "kind": "LinkedField",
      "name": "templateTypeCollection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TaxonomyTemplateType",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Sys",
              "kind": "LinkedField",
              "name": "sys",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "templatePreviews",
      "args": null,
      "concreteType": "AssetCollection",
      "kind": "LinkedField",
      "name": "templatePreviewCollection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Asset",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductTemplate",
  "abstractKey": null
};

(node as any).hash = "dad8d8814494331f36c5867d050c8524";

export default node;
